/* Cuddypup: compact Mageworx cross-sell popup with six products per desktop page. */
(() => {
  if (window.__cuddypupMageworxUpsellPopup) return;
  window.__cuddypupMageworxUpsellPopup = true;

  const STYLE_ID = 'cuddypup-mageworx-upsell-popup';
  const desktopMedia = window.matchMedia('(min-width: 768px)');
  const tabletMedia = window.matchMedia('(min-width: 576px)');
  const boundButtons = new WeakSet();
  const boundSliders = new WeakSet();
  const observedRoots = new WeakSet();
  const observedCartDrawers = new WeakSet();
  let documentScheduled = false;

  const styles = `
    /* Keep the dialog geometrically centered; safe center avoids clipping on short screens. */
    .Modal.Modal {
      display: flex !important;
      align-items: safe center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      min-height: 100% !important;
      padding: 32px !important;
    }

    /* Mageworx nests the panel in a full-viewport wrapper. Neutralize that
       wrapper so the panel, rather than the wrapper, is what gets centered. */
    .Modal.Modal > div:first-child {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: 0 !important;
      padding: 0 !important;
    }

    .Modal.Modal > div:first-child > span[aria-hidden="true"] {
      display: none !important;
    }

    .Modal__Content.Modal__Content {
      max-width: 900px !important;
      max-height: calc(100dvh - 64px) !important;
      overflow-y: auto !important;
      background: #FFFDF6 !important;
      border: 0 !important;
      border-radius: 4px !important;
      box-shadow: none !important;
    }

    .Modal-Header,
    .Offer {
      background: #FFFDF6 !important;
    }

    .Offer {
      padding: 22px 20px 20px !important;
    }

    .Offer__Heading {
      width: 100% !important;
      max-width: 816px !important;
      margin: 0 0 12px !important;
      margin-right: auto !important;
      margin-left: auto !important;
    }

    .ProductSlider__Wrapper,
    .ProductSlider--slidesWrapper {
      height: auto !important;
    }

    .ProductSlider--slidesWrapper {
      width: 100% !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    .ProductSlider.ProductSlider {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 12px !important;
      width: 100% !important;
      max-width: 816px !important;
      height: auto !important;
      margin-right: auto !important;
      margin-left: auto !important;
      overflow: visible !important;
    }

    .Slide.Slide {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      gap: 8px !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      height: 228px !important;
      min-height: 228px !important;
      padding: 10px !important;
      transform: none !important;
      background: #FFFDF6 !important;
      border: 1px solid #E8DED2 !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
    }

    .Slide.cuddypup-mw-popup-hidden {
      display: none !important;
    }

    .Slide__SlideImage {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      height: 74px !important;
      min-height: 74px !important;
      background: #FFFDF6 !important;
    }

    .Slide__SlideImage a {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      height: 100% !important;
    }

    .Slide__SlideImage img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
    }

    .Slide__SlideContent {
      display: flex !important;
      flex: 0 0 124px !important;
      flex-direction: column !important;
      align-items: center !important;
      gap: 6px !important;
      width: 100% !important;
      height: 124px !important;
      min-height: 124px !important;
      max-height: 124px !important;
      margin-top: 0 !important;
      padding: 0 !important;
      text-align: center !important;
    }

    .CrossellSlide__Pricing {
      display: flex !important;
      flex: 0 0 50px !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 2px !important;
      width: 100% !important;
      height: 50px !important;
      min-height: 50px !important;
      text-align: center !important;
    }

    .CrossellSlide__Pricing p {
      width: 100% !important;
      margin: 0 !important;
      font-size: 13px !important;
      line-height: 1.2 !important;
      text-align: center !important;
    }

    .Slide__SlideContent > .flex {
      display: flex !important;
      flex: 0 0 68px !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 0 !important;
      width: 100% !important;
      height: 68px !important;
      min-height: 68px !important;
      max-height: 68px !important;
      margin-top: 0 !important;
    }

    .Slide__SlideContent > .flex > * {
      margin-top: 0 !important;
    }

    .Slide__SlideContent > .flex > * + * {
      margin-top: 6px !important;
    }

    /* A compact version of the theme's single-border quantity selector. */
    .QuantityInput {
      display: grid !important;
      grid-template-columns: 30px 30px 30px !important;
      width: 92px !important;
      height: 32px !important;
      min-height: 32px !important;
      margin: 0 auto !important;
      overflow: hidden !important;
      background: transparent !important;
      border: 1px solid #e95c4d !important;
      border-radius: 4px !important;
      box-shadow: none !important;
    }

    .QuantityInput .Labelled--srOnly {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    .QuantityInput__Button {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 30px !important;
      min-width: 30px !important;
      height: 30px !important;
      padding: 0 !important;
      color: #e95c4d !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    .QuantityInput__Button:first-child {
      color: #e95c4d !important;
    }

    .QuantityInput__Button svg {
      width: 10px !important;
      height: 10px !important;
    }

    .QuantityInput__Control {
      width: 30px !important;
      height: 30px !important;
      min-height: 30px !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #e95c4d !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-size: 13px !important;
      line-height: 30px !important;
      text-align: center !important;
    }

    .Button {
      justify-content: center !important;
      width: 120px !important;
      min-width: 120px !important;
      height: 32px !important;
      min-height: 32px !important;
      margin: 0 auto !important;
      padding: 5px 12px !important;
      border-radius: 4px !important;
    }

    .Button__Text {
      font-size: 13px !important;
      line-height: 1.1 !important;
    }

    .ProductSlider__NavigationDots {
      display: none !important;
    }

    .cuddypup-mw-popup-dots {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      padding: 12px 0 0 !important;
    }

    .cuddypup-mw-popup-dot {
      width: 9px !important;
      min-width: 9px !important;
      height: 9px !important;
      padding: 0 !important;
      background: #E8DED2 !important;
      border: 0 !important;
      border-radius: 50% !important;
      box-shadow: none !important;
    }

    .cuddypup-mw-popup-dot[aria-current="true"] {
      background: #e95c4d !important;
    }

    .Modal-Header {
      justify-content: flex-start !important;
      padding: 12px 20px !important;
      text-align: left !important;
    }

    .Modal-Header__Headline {
      flex: 1 1 auto !important;
      justify-content: flex-start !important;
      text-align: left !important;
    }

    .Modal-Header__HeadlineText {
      text-align: left !important;
    }

    .Modal-Header__CartLink {
      display: none !important;
      margin: 0 !important;
      padding: 0 !important;
      background-image: none !important;
      border: 0 !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      text-decoration: none !important;
      transition: color .2s ease !important;
    }

    .Modal-Header__CartLink:hover,
    .Modal-Header__CartLink:focus-visible {
      color: #7ea2fc !important;
    }

    /* Keep a comfortable click target while reducing the visible close icon. */
    .Modal-Header__CloseButton {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 28px !important;
      height: 28px !important;
      margin-left: 20px !important;
      padding: 0 !important;
      overflow: visible !important;
      background: transparent !important;
      border: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
      color: #e95c4d !important;
    }

    .Modal-Header__CloseButton:hover,
    .Modal-Header__CloseButton:focus,
    .Modal-Header__CloseButton:focus-visible {
      color: #e95c4d !important;
      background: transparent !important;
      border: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    .Modal-Header__CloseButton svg {
      width: 20px !important;
      height: 20px !important;
      overflow: visible !important;
      transform: scale(.6) !important;
      transform-origin: center !important;
    }

    .ProductSlider__NavigationButton {
      color: #e95c4d !important;
    }

    @keyframes cuddypup-mw-popup-enter-next {
      from {
        opacity: .45;
        transform: translateX(32px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes cuddypup-mw-popup-enter-previous {
      from {
        opacity: .45;
        transform: translateX(-32px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .ProductSlider.cuddypup-mw-popup-slide-next {
      animation: cuddypup-mw-popup-enter-next .28s cubic-bezier(.4, 0, .2, 1) !important;
    }

    .ProductSlider.cuddypup-mw-popup-slide-previous {
      animation: cuddypup-mw-popup-enter-previous .28s cubic-bezier(.4, 0, .2, 1) !important;
    }

    @media (prefers-reduced-motion: reduce) {
      .ProductSlider.cuddypup-mw-popup-slide-next,
      .ProductSlider.cuddypup-mw-popup-slide-previous {
        animation: none !important;
      }
    }

    .ProductSlider__NavigationButton--alignLeft {
      left: -8px !important;
    }

    .ProductSlider__NavigationButton--alignRight {
      right: -8px !important;
    }

    @media (min-width: 768px) {
      .Modal-Header {
        padding: 12px 42px !important;
      }
    }

    @media (max-width: 767px) {
      .Offer {
        padding: 18px 20px 16px !important;
      }

      .Offer__Heading {
        max-width: none !important;
      }

      .ProductSlider.ProductSlider {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        max-width: none !important;
      }
    }

    @media (max-width: 575px) {
      .Modal.Modal {
        padding: 8px 10px !important;
      }

      .Modal__Content.Modal__Content {
        width: calc(100% - 20px) !important;
        max-height: calc(100dvh - 16px) !important;
        overflow-y: auto !important;
      }

      .Modal-Header {
        padding: 8px 20px !important;
      }

      .Offer {
        padding: 10px 20px !important;
      }

      .Offer__Heading {
        margin-bottom: 8px !important;
      }

      .Modal-Header__Headline {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        min-width: 0 !important;
      }

      .Modal-Header__HeadlineIcon,
      .Modal-Header__HeadlineText {
        display: block !important;
      }

      .Modal-Header__HeadlineText {
        font-size: 16px !important;
        line-height: 1.2 !important;
        white-space: nowrap !important;
      }

      .ProductSlider.ProductSlider {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 8px !important;
      }

      .Slide.Slide {
        height: 208px !important;
        min-height: 208px !important;
        padding: 8px !important;
        gap: 6px !important;
      }

      .Slide__SlideImage {
        height: 60px !important;
        min-height: 60px !important;
      }

      .cuddypup-mw-popup-dots {
        padding-top: 8px !important;
      }
    }
  `;

  const pageSize = () => {
    if (desktopMedia.matches) return 6;
    return 4;
  };

  const scheduleRoot = (host, root) => {
    if (root.__cuddypupUpsellScheduled) return;
    root.__cuddypupUpsellScheduled = true;
    window.requestAnimationFrame(() => {
      root.__cuddypupUpsellScheduled = false;
      enhance(host, root);
    });
  };

  const animatePageChange = (host, slider) => {
    const direction = host.dataset.cuddypupMwDirection;
    if (!direction) return;
    delete host.dataset.cuddypupMwDirection;

    const nextClass = 'cuddypup-mw-popup-slide-next';
    const previousClass = 'cuddypup-mw-popup-slide-previous';
    const activeClass = direction === 'previous' ? previousClass : nextClass;

    slider.classList.remove(nextClass, previousClass);
    void slider.offsetWidth;
    slider.classList.add(activeClass);

    window.setTimeout(() => {
      slider.classList.remove(activeClass);
    }, 300);
  };

  const bindArrow = (button, host, root, direction) => {
    if (!button || boundButtons.has(button)) return;
    boundButtons.add(button);

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const slides = [...root.querySelectorAll('.ProductSlider > .Slide')]
        .filter((slide) => !slide.classList.contains('cuddypup-mw-stock-hidden'));
      const count = Math.max(1, Math.ceil(slides.length / pageSize()));
      const current = Number(host.dataset.cuddypupMwPage || 0);
      const nextPage = Math.max(0, Math.min(count - 1, current + direction));
      if (nextPage === current) return;
      host.dataset.cuddypupMwDirection = direction > 0 ? 'next' : 'previous';
      host.dataset.cuddypupMwPage = String(nextPage);
      scheduleRoot(host, root);
    }, { capture: true });
  };

  const bindSwipe = (slider, host, root) => {
    if (!slider || boundSliders.has(slider)) return;
    boundSliders.add(slider);

    let startX = null;
    let startY = null;

    slider.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchend', (event) => {
      if (startX === null || startY === null || event.changedTouches.length !== 1) {
        startX = null;
        startY = null;
        return;
      }

      const deltaX = event.changedTouches[0].clientX - startX;
      const deltaY = event.changedTouches[0].clientY - startY;
      startX = null;
      startY = null;

      if (desktopMedia.matches) return;
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;

      const direction = deltaX < 0 ? 1 : -1;
      const slides = [...root.querySelectorAll('.ProductSlider > .Slide')]
        .filter((slide) => !slide.classList.contains('cuddypup-mw-stock-hidden'));
      const count = Math.max(1, Math.ceil(slides.length / pageSize()));
      const current = Number(host.dataset.cuddypupMwPage || 0);
      const nextPage = Math.max(0, Math.min(count - 1, current + direction));
      if (nextPage === current) return;

      host.dataset.cuddypupMwDirection = direction > 0 ? 'next' : 'previous';
      host.dataset.cuddypupMwPage = String(nextPage);
      scheduleRoot(host, root);
    }, { passive: true });

    slider.addEventListener('touchcancel', () => {
      startX = null;
      startY = null;
    }, { passive: true });
  };

  const closeMobileCartDrawer = (root) => {
    const themeDrawers = [...document.querySelectorAll('cart-drawer#Cart-Drawer')];

    themeDrawers.forEach((drawer) => {
      if (observedCartDrawers.has(drawer)) return;
      observedCartDrawers.add(drawer);
      const observer = new MutationObserver(scheduleDocument);
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    });

    if (desktopMedia.matches) return;

    const mageworxIsOpen = root
      ? Boolean(root.querySelector('.Modal'))
      : [...document.querySelectorAll('mw-offers-dialog')].some(
        (host) => Boolean(host.shadowRoot?.querySelector('.Modal'))
      );

    if (!mageworxIsOpen) return;

    document.querySelectorAll('dialog.push-cart-dialog[open]').forEach((drawer) => {
      drawer.close?.();
    });

    themeDrawers.forEach((drawer) => {
      if (!drawer.classList.contains('active')) return;
      drawer.querySelector('side-panel-close')?.click();
    });
  };

  function enhance(host, root) {
    if (!root.querySelector(`#${STYLE_ID}`)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = styles;
      root.appendChild(style);
    }

    closeMobileCartDrawer(root);

    const slider = root.querySelector('.ProductSlider');
    const slides = slider
      ? [...slider.querySelectorAll(':scope > .Slide')]
        .filter((slide) => !slide.classList.contains('cuddypup-mw-stock-hidden'))
      : [];
    if (!slider || !slides.length) return;

    bindSwipe(slider, host, root);

    const size = pageSize();
    const pageCount = Math.max(1, Math.ceil(slides.length / size));
    const requestedPage = Number(host.dataset.cuddypupMwPage || 0);
    const page = Math.max(0, Math.min(pageCount - 1, requestedPage));
    host.dataset.cuddypupMwPage = String(page);

    slides.forEach((slide, index) => {
      slide.classList.toggle(
        'cuddypup-mw-popup-hidden',
        Math.floor(index / size) !== page
      );
    });

    animatePageChange(host, slider);

    let dots = root.querySelector('.cuddypup-mw-popup-dots');
    const signature = `${slides.length}:${size}`;

    if (!dots || dots.dataset.signature !== signature) {
      dots?.remove();
      dots = document.createElement('div');
      dots.className = 'cuddypup-mw-popup-dots';
      dots.dataset.signature = signature;
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Cross-sell product pages');

      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cuddypup-mw-popup-dot';
        dot.setAttribute('aria-label', `Show products page ${index + 1}`);
        dot.addEventListener('click', () => {
          const current = Number(host.dataset.cuddypupMwPage || 0);
          if (index === current) return;
          host.dataset.cuddypupMwDirection = index > current ? 'next' : 'previous';
          host.dataset.cuddypupMwPage = String(index);
          scheduleRoot(host, root);
        });
        dots.appendChild(dot);
      }

      root.querySelector('.ProductSlider__Wrapper')?.after(dots);
    }

    [...dots.querySelectorAll('.cuddypup-mw-popup-dot')].forEach((dot, index) => {
      dot.setAttribute('aria-current', String(index === page));
    });

    const previous = root.querySelector(
      '.ProductSlider__NavigationButton--alignLeft'
    );
    const next = root.querySelector(
      '.ProductSlider__NavigationButton--alignRight'
    );

    bindArrow(previous, host, root, -1);
    bindArrow(next, host, root, 1);

    if (previous) previous.disabled = page === 0;
    if (next) next.disabled = page === pageCount - 1;
  }

  const install = (host) => {
    const root = host.shadowRoot;
    if (!root) return;

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      const observer = new MutationObserver(() => scheduleRoot(host, root));
      observer.observe(root, { childList: true, subtree: true });
    }

    scheduleRoot(host, root);
  };

  const scan = () => {
    documentScheduled = false;
    document.querySelectorAll('mw-offers-dialog').forEach(install);
    closeMobileCartDrawer();
  };

  const scheduleDocument = () => {
    if (documentScheduled) return;
    documentScheduled = true;
    window.requestAnimationFrame(scan);
  };

  const documentObserver = new MutationObserver(scheduleDocument);
  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open'],
  });

  desktopMedia.addEventListener?.('change', scheduleDocument);
  tabletMedia.addEventListener?.('change', scheduleDocument);
  window.addEventListener('resize', scheduleDocument, { passive: true });
  scheduleDocument();
})();
